/** Shown under every "new password" field. */
export const PASSWORD_HINT =
  'At least 8 characters, not only digits, and not containing the mobile number or email.';

/**
 * The quick checks of the API's password policy, so obvious mistakes are caught before
 * sending. The API applies the full policy (common passwords, the account's mobile and email)
 * and its message is shown on the field.
 */
export function checkNewPassword(password: string): string | undefined {
  if (!password) return 'Enter a password.';
  if (password.length < 8) return 'Use at least 8 characters.';
  if (password.length > 128) return 'Use at most 128 characters.';
  if (password.trim() !== password) return 'Remove the space at the start or end.';
  if (/^\d+$/.test(password)) return 'Add letters or symbols; only digits is not allowed.';
  return undefined;
}

/** Checks a confirmation field against the new password. */
export function checkConfirmation(password: string, confirmation: string): string | undefined {
  if (!confirmation) return 'Re-enter the new password.';
  if (confirmation !== password) return 'Passwords do not match.';
  return undefined;
}
